import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdmin } from './AdminContext';
import { CoverageGrid } from './CoverageGrid';
import { COVERAGE_TARGETS, poolTarget, type CoverageTarget } from '../../../../shared/src/taxonomyV2';
import { poolGaps } from './CoverageTargets';

/**
 * The coverage map, full page.
 *
 * It renders the same CoverageGrid the factory uses as its map view, so the two
 * screens cannot drift. The previous version of this page had its own rendering
 * and read the retired v1 taxonomy: it drew 498 tiles, most of them showing (0)
 * for topics nobody generates to any more, which made the pool look empty and
 * invited generating against a dead tree.
 *
 * Generation itself lives in the factory. This page finds the hole and hands
 * off, rather than owning a second copy of the job builder.
 */
export function CoverageMap() {
  const { realmStats } = useAdmin();
  const navigate = useNavigate();
  const [target, setTarget] = useState<CoverageTarget>(COVERAGE_TARGETS[0]);

  const gaps = poolGaps(realmStats, target);
  const poolHave = gaps.reduce((s, g) => s + g.have, 0);
  const poolNeed = gaps.reduce((s, g) => s + g.gap, 0);
  const met = gaps.filter(g => g.gap === 0).length;
  const emptyTopics = gaps.reduce((s, g) => s + g.empty, 0);

  return (
    <div>
      <h2 className="admin-section-title" style={{ marginBottom: 16 }}>COVERAGE MAP</h2>

      <div className="admin-card" style={{ marginBottom: 16 }}>
        <div style={{ display: 'flex', gap: 10, marginBottom: 14, flexWrap: 'wrap' }}>
          {COVERAGE_TARGETS.map(t => {
            const active = t.key === target.key;
            return (
              <button
                key={t.key}
                onClick={() => setTarget(t)}
                className="admin-btn admin-btn-sm"
                style={{
                  background: active ? '#c4973a' : '#16223A',
                  color: active ? '#000' : '#ccccd4',
                  border: `1px solid ${active ? '#c4973a' : '#33415E'}`,
                  fontWeight: active ? 700 : 500,
                }}
              >
                {t.label} · {t.perTopic}/konu
              </button>
            );
          })}
        </div>
        <div style={{ display: 'flex', gap: 26, flexWrap: 'wrap', fontSize: '0.8rem' }}>
          <span style={{ color: '#ccccd4' }}>
            <strong style={{ color: '#eee', fontFamily: 'var(--font-mono)', fontSize: '1.1rem' }}>
              {poolHave.toLocaleString('tr-TR')}
            </strong> / {poolTarget(target).toLocaleString('tr-TR')} soru
          </span>
          <span style={{ color: met === 10 ? '#14b8a6' : '#c4973a' }}>{met}/10 realm hedefte</span>
          {emptyTopics > 0 && <span style={{ color: '#f43f5e' }}>{emptyTopics} konu tamamen bos</span>}
          <span style={{ marginLeft: 'auto', color: poolNeed ? '#c4973a' : '#14b8a6', fontWeight: 600 }}>
            {poolNeed ? `${poolNeed.toLocaleString('tr-TR')} soru eksik` : 'hedef tamam'}
          </span>
        </div>
      </div>

      <div className="admin-card">
        <CoverageGrid
          stats={realmStats}
          target={target}
          onPickRealm={() => navigate('/sys/wotgate/factory')}
          onPickTopic={() => navigate('/sys/wotgate/factory')}
        />
        <button
          className="admin-btn"
          style={{ marginTop: 16, width: '100%' }}
          onClick={() => navigate('/sys/wotgate/factory')}
        >
          FABRIKAYA GIT VE URET
        </button>
      </div>
    </div>
  );
}
